import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { ApplicationsCreateState } from '../reducers/applications-create.reducer';
import { applicationsCreateActions } from '../actions';

@Injectable()
export class ApplicationsCreateFacade {
  private readonly store: Store<ApplicationsCreateState> = inject(Store);

  public create(containerId: string): void {
    this.store.dispatch(applicationsCreateActions.create({ containerId }));
  }
}
